import type {
  BetterstartCommandRuntime,
  CreateCommandOptions,
  CreateSchemaKind
} from '@cli-types/core-engine/commands.js'
import { CREATE_SCHEMA_KINDS } from '@cli-constants/commands.js'
import { renderCommandHelpText } from '@core-engine/templates/renderers/commands/command-help.js'
import { Argument, Command } from 'commander'

export function createCreateCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('create')
    .description('Interactively create and generate a user-authored schema')
    .addArgument(
      new Argument('<kind>', 'Schema kind: entity, single, or form').choices(CREATE_SCHEMA_KINDS)
    )
    .argument('[name]', 'Optional schema name override (derived from label when omitted)')
    .option('--cwd <path>', 'Project root path')
    .option('--skip-migration', 'Skip running db:push after generation', false)
    .option(
      '--accept-generated',
      'Accept generated output for files that would otherwise get merge conflicts',
      false
    )
    .addHelpText('after', renderCommandHelpText('create'))
    .action(
      (kind: CreateSchemaKind, schemaName: string | undefined, options: CreateCommandOptions) =>
        runtime.runCreate(kind, schemaName, options)
    )
}
